import { plainToClass } from 'class-transformer'
import Matching from '@/models/matching'
import Response from '@/utils/response'
import mPageLoading from '@/mixins/page-loading'
import mPageTitle from '@/mixins/page-title'
import mPagination from '@/mixins/pagination'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
  },
  mixins: [
    mPageLoading,
    mPageTitle,
    mPagination,
  ],
  title () {
    return this.$t("pages.user.matchings.logs.title")
  },
  props: {
    repository: Object
  },
  data: () => ({
    processing: false,
    matchings: [],
  }),
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.logs({
          params: this.pageParams()
        }))
        this.matchings = plainToClass(Matching, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    pageChange (num) {
      this.pagination.page = num
      this.fetchData()
    },
    onResult (matching) {
      this.$router.push({
        name: 'matching-summary',
        params: { id: matching.id },
      })
    },
  },
}
